import { get, IRequestOptions, post } from '@apis/api';
import { CommonResponse } from '@wconcept/wconcept-common/models/display/common';
import {
  GnbPcInfo,
  GnbPcMegaMenuInfo,
  NewGnbInfo,
  NewGnbInfoV2,
} from '@wconcept/wconcept-common/models/renewal/gnb';
import { Product } from '@wconcept/wconcept-common/models/renewal/product';

const baseURL = process.env.NEXT_PUBLIC_DISPLAY_API_GATEWAY_URL;
const options = {
  headers: {
    'Content-Type': 'application/json; charset=utf-8', // 필요에 따라 헤더 수정
    'DISPLAY-API-KEY': process.env.NEXT_PUBLIC_DISPLAY_API_GATEWAY_KEY || '',
  },
};

export interface GnbPcInfoResponse extends CommonResponse {
  data: GnbPcInfo;
}
export interface NewGnbInfoResponse extends CommonResponse {
  data: NewGnbInfoV2;
}
export interface GnbPcMegaMenuInfoResponse extends CommonResponse {
  data: GnbPcMegaMenuInfo;
}

/**
 * GNB 조회(mo/pc 공통)
 */

export const requestNewGnbInfo = async (optionParams: IRequestOptions = {}) => {
  const { data } = await get<NewGnbInfoResponse>({
    url: `/display/api/menu/v2/gnb`,
    options: {
      ...options,
      ...optionParams,
      headers: {
        ...options.headers,
        ...optionParams?.headers,
      },
    },
    baseUrl: baseURL,
  });
  return data;
};

export const GET_GNB_PC_MEGA_MENU_API = () =>
  '/display/api/menu/v2/gnb/pc/mega-menu';

export const requestGnbPcMegaMenuInfo = async (
  optionParams: IRequestOptions = {}
) => {
  const { data } = await get<GnbPcMegaMenuInfoResponse>({
    url: GET_GNB_PC_MEGA_MENU_API(),
    options: {
      ...options,
      ...optionParams,
      headers: {
        ...options.headers,
        ...optionParams.headers,
      },
    },
    baseUrl: baseURL,
  });
  return data;
};

// (신)gnb
// export const GET_NEW_GNB_INFO_API = () => `/display/api/v3/gnb`;
// export const requestNewGnbInfo = async () => {
//   const { data } = await get<NewGnbInfoResponse>({
//     url: GET_NEW_GNB_INFO_API(),
//     baseUrl: baseURL,
//     options,
//   });
//   // const { data } = await axiosDisplay.get<NewGnbInfoResponse>(
//   //   GET_NEW_GNB_INFO_API()
//   // );
//   return data;
// };

export const GET_GNB_PC_INFO_API = (memberGrade: string) =>
  `/display/api/v2/gnb/pc?memberGrade=${memberGrade}`;
export const requestGnbPcInfo = async (memberGrade: string) => {
  const { data } = await get<GnbPcInfoResponse>({
    url: GET_GNB_PC_INFO_API(memberGrade),
    baseUrl: baseURL,
    options: { ...options },
  });
  // const { data } = await axiosDisplay.get<GnbPcInfoResponse>(
  //   GET_GNB_PC_INFO_API(memberGrade)
  // );
  return data;
};

export interface GnbPcCategoryProductsResponse extends CommonResponse {
  data: {
    categoryProductList: Product[];
  };
}

export const GET_GNB_PC_CATEGORY_PRODUCTS_API = (mediumCd: string) =>
  `/display/api/v2/gnb/pc/category/products/${mediumCd}`;
export const requestGnbPcCategoryProducts = async (mediumCd: string) => {
  const { data } = await get<GnbPcCategoryProductsResponse>({
    url: GET_GNB_PC_CATEGORY_PRODUCTS_API(mediumCd),
    baseUrl: baseURL,
    options,
  });
  // const { data } = await axiosDisplay.get<GnbPcCategoryProductsResponse>(
  //   GET_GNB_PC_CATEGORY_PRODUCTS_API(mediumCd)
  // );
  return data;
};
